import {
	Box,
	Button,
	Container,
	Paper,
	Tab,
	Tabs,
	Typography
} from '@mui/material';
import { Modal, Subheader } from 'components';
import { useEffect, useState } from 'react';
import InPersonEventDetails from './InPersonEventDetails';
import InPersonEventParticipants from './InPersonEventParticipants';
import { useNavigate, useParams } from 'react-router-dom';
import { useAlerts, useInPersonEvents } from 'hooks';

export default function InPersonEventShow() {
	const navigate = useNavigate();
	const { id } = useParams();
	const {
		fetchInPersonEvent,
		inPersonEvent,
		isLoading,
		exportCsv,
		destroyInPersonEvent,
		fetchParticipants,
		participants,
		participantsMeta,
		isLoadingParticipants
	} = useInPersonEvents();
	const { showAlertError, showAlertSuccess } = useAlerts();

	const [tabValue, setTabValue] = useState(0);
	const [showDeleteModal, setShowDeleteModal] = useState(false);

	const handleTabChange = (ev, value) => {
		setTabValue(value);
	};

	const handleDelete = async () => {
		const response = await destroyInPersonEvent(inPersonEvent);

		if (response && response.message) {
			showAlertSuccess(response.message);
		} else {
			showAlertError('Unable to delete event, try again later');
		}

		navigate(-1);
	};

	useEffect(() => {
		fetchInPersonEvent(id);
	}, [id]);

	return (
		<div>
			<Subheader
				title={isLoading ? 'Loading..' : inPersonEvent.name}
				buttons={[
					<Button
						variant="contained"
						color="primary"
						onClick={() => navigate(`/in-person-events/${id}/edit`)}
					>
						Edit
					</Button>,
					<Button
						variant={'outlined'}
						color={'error'}
						onClick={() => setShowDeleteModal(true)}
					>
						Delete
					</Button>
				]}
			/>

			<Container>
				<Tabs value={tabValue} onChange={handleTabChange}>
					<Tab label="Event Details" value={0} />
					<Tab label="Participants" value={1} />
				</Tabs>

				{tabValue === 0 && (
					<InPersonEventDetails inPersonEvent={inPersonEvent} />
				)}

				{tabValue === 1 && (
					<InPersonEventParticipants
						eventName={inPersonEvent.name}
						exportCsv={exportCsv}
						id={id}
						fetchParticipants={fetchParticipants}
						participants={participants}
						page={participantsMeta.page}
						num_pages={participantsMeta.num_pages}
						per_page={participantsMeta.per_page}
						isLoading={isLoadingParticipants}
					/>
				)}
			</Container>

			<Modal
				maxWidth={'xs'}
				title={'Delete Event?'}
				open={showDeleteModal}
				handleClose={() => setShowDeleteModal(false)}
			>
				<Typography>{'Are you sure you want to delete this event?'}</Typography>
				<Box
					display={'flex'}
					gap={2}
					flexDirection={'row'}
					justifyContent={'flex-end'}
				>
					<Button color={'secondary'} onClick={() => setShowDeleteModal(false)}>
						{'Cancel'}
					</Button>
					<Button color={'error'} onClick={handleDelete}>
						{'Confirm'}
					</Button>
				</Box>
			</Modal>
		</div>
	);
}
